import { login, logout, getInfo, GetPcSet } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import router, { resetRouter } from '@/router'

const state = {
  token: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  roles: [],
  sessionId: '',
  title_name: '',
  address: '',
  count1: '',
  def_up_code: JSON.parse(sessionStorage.getItem(`def_up_code`)) || '',
  ip_gps_os_data: JSON.parse(sessionStorage.getItem(`ip_gps_os_data`)) || '',

  case_information: JSON.parse(sessionStorage.getItem(`case_information`)) || '',
  web_means: JSON.parse(sessionStorage.getItem(`GET_WEB_MEANS`)) || '',
  web_name: JSON.parse(sessionStorage.getItem(`GET_WEB_NAME`)) || ''
}

const mutations = {
  CASE_INFOID: (state, case_information) => {
    state.case_information = case_information
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  DEF_UP_CODE: (state, def_up_code) => {
    state.def_up_code = def_up_code
  },
  SESSION_ID: (state, sessionId) => {
    state.sessionId = sessionId
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },

  GET_WEB_MEANS(state, data) {
    let name = ''
    for (const v of data) {
      if (v.layoutId == 'OFFICIAL_TEXT') {
        for (const i of v.imgs) {
          if (i.imgName == '官网名称') {
            name = i.layoutLink
          }
        }
      }
    }
    sessionStorage.setItem('GET_WEB_NAME', JSON.stringify(name))

    state.web_means = data
    state.web_name = name
  }
}
const actions = {
  GetWebMeans({ commit }, data) {
    commit('GET_WEB_MEANS', data)

    sessionStorage.setItem('GET_WEB_MEANS', JSON.stringify(data))
  },
  GetWebMeansNew({ commit }, data) {
    return new Promise((resolve, reject) => {
      GetPcSet().then(response => {
        sessionStorage.setItem('GET_WEB_MEANS', JSON.stringify(response.data))

        commit('GET_WEB_MEANS', response.data)

        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  addAction(context) {
    context.commit('add', 10)
  },
  // user login
  login({ commit }, userInfo) {
    const { userName, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ userName: userName, password: password }).then(response => {
        const { data } = response
        const data_list = {
          token: data.token,
          user_type: 'def', // 根据需求直接干死
          sessionId: 'tvhnr37giv2p99mj3kbgvbu91k',
          menusList: [
            {
              child: [
                {
                  child: [
                    {
                      icon: '',
                      id: 155,
                      level: 3,
                      menu: '',
                      menu_type: 1,
                      module: 'Card',
                      rule_id: 352,
                      selected: false,
                      sort: 0,
                      status: 1,
                      title: '卡密导入列',
                      url: '/home/cardmanage/list'
                    }
                  ],
                  icon: '',
                  id: 154,
                  level: 2,
                  menu: '',
                  menu_type: 1,
                  module: 'Card',
                  rule_id: 350,
                  selected: false,
                  sort: 0,
                  status: 1,
                  title: '卡密批次管理',
                  url: ''
                }
              ],
              icon: '',
              id: 153,
              level: 1,
              menu: '',
              menu_type: 1,
              module: 'Card',
              rule_id: 349,
              selected: false,
              sort: 9,
              status: 1,
              title: '卡密池',
              url: ''
            }
          ],
          userInfo: {
            create_time: null,
            id: 1,
            phone: '18580801231',
            post_id: 5,
            realname: '超级管理员',
            remark: '',
            status: 1,
            structure_id: 1,
            union_id: null,
            username: 'lsxd'
          }

        }
        // data.token='admin-tiken'
        sessionStorage.setItem('user', JSON.stringify(data_list))
        sessionStorage.setItem('user_type', JSON.stringify(data_list.user_type))
        // let newdata = {
        //   token :'admin-tiken'
        // }
        commit('SET_TOKEN', data_list.token)
        // commit('USER_TYPE', data_list.user_type)
        setToken(data_list.token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        // const { data } = response
        const sessionId = JSON.parse(sessionStorage.getItem('user'))
        const data = {
          defAddress: response.data.defAddress,
          defAddressArea: response.data.defAddressArea,
          defAddressCity: response.data.defAddressCity,
          defAddressProvince: response.data.defAddressProvince,
          defBirth: response.data.defBirth,
          defEmail: response.data.defEmail,
          defGender: response.data.defGender,
          defIdCard: response.data.defIdCard,
          defName: response.data.defName,
          defNationality: response.data.defNationality,
          defPhone: response.data.defPhone,
          id: response.data.id,
          avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
          introduction: 'I am a super',
          name: 'Super Admin',
          roles: [
            'admin'
          ],
          sessionIds: sessionId.sessionId
        }
        sessionStorage.setItem('user_list', JSON.stringify(response))

        if (!data) {
          reject('Verification failed, please Login again.')
        }

        const { roles, name, avatar, introduction, sessionIds, id } = data

        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!')
        }

        commit('SET_ROLES', roles)
        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        commit('SET_INTRODUCTION', introduction)
        commit('SESSION_ID', sessionIds)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      // const data = {
      //   authKey :state.token,
      //   sessionId :sessionId.sessionId
      // }
      const data = { authkey: state.token, sessionId: state.sessionId }
      sessionStorage.clear()

      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resetRouter()
      // reset visited views and cached views
      // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
      dispatch('tagsView/delAllViews', null, { root: true })
      resolve()

      //
      // logout(data).then(() => {
      //   commit('SET_TOKEN', '')
      //   commit('SET_ROLES', [])
      //   removeToken()
      //   resetRouter()
      //   // reset visited views and cached views
      //   // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
      //   dispatch('tagsView/delAllViews', null, { root: true })
      //   resolve()
      // }).catch(error => {
      //   reject(error)
      // })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

  // dynamically modify permissions
  changeRoles({ commit, dispatch }, role) {
    return new Promise(async resolve => {
      const token = role + '-token'

      commit('SET_TOKEN', token)
      setToken(token)

      const { roles } = await dispatch('getInfo')

      resetRouter()

      // generate accessible routes map based on roles
      const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })

      // dynamically add accessible routes
      router.addRoutes(accessRoutes)

      // reset visited views and cached views
      dispatch('tagsView/delAllViews', null, { root: true })

      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
